
;
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"custom","lightbox":"no"};
                    const ID = 'ecom-7spo4jvd7k4';
                    document.querySelectorAll('.ecom-7spo4jvd7k4').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        var e=this.$el;if(e&&this.isLive){var t=e.querySelectorAll(".element-social-link");t.length&&t.forEach(function(n){var r=n.getAttribute("href")||"#",i=r.replace("{current-link}",location.href);n.setAttribute("href",i)})}
                    
                    });
                    const settings = {};
                    const ID = 'ecom-x04au9ua6vp';
                    document.querySelectorAll('.ecom-x04au9ua6vp').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            ;window.addEventListener("load",()=>{
                let isAdmin = false;
                if(document.querySelector("#admin-bar-iframe")){
                    isAdmin = true;
                }
                if(!isAdmin) {
                    if(window.EComposerBrand) {
                        return;
                    } else {
                        window.EComposerBrand = true;
                    }
                }
                let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 15px","width: 100%","text-align: center","opacity: 1","text-indent: 0","color: #333","background: #fff",""].join(" !important;")),b.innerHTML="Made with &hearts; by <a href=\"https://ecomposer.io/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content="+window.location.origin+"\" target=\"_blank\">EComposer</a>" + (isAdmin ? ". Contact us or upgrade to remove branding" :""),a.appendChild(b)
            });